import { useActiveSalesCampaignCodes } from "~/features/salesCampaign/hooks/useActiveSalesCampaignCodes";
import { useDispatch, useSelector } from "react-redux";
import { type RootState } from "~/app/store";
import { toggleCampaignOnlyResultsThunk } from "~/features/search/redux/actions";

import { SaleTag } from "~/domains/salesCampaign/components/SaleTag/SaleTag";
import { useTranslation } from "react-i18next";
import { selectIsFilterActive } from "~/features/search/redux/searchSelectors";
import { Stack, styled, Typography } from "~/common/mui";
import { ICON_MARGIN } from "~/styles/cssConstants";
import { Switch } from "~/common/components/Switch/Switch";

interface Props {
  className?: string;
}

export const SalesFilter = (props: Props) => {
  const { t } = useTranslation();
  const activeSalesCampaignCodes = useActiveSalesCampaignCodes();

  const isActive = useSelector(selectIsFilterActive);
  const hasCampaignResults = useSelector((state: RootState) => state.srp.results.hasCampaignResults);
  const dispatch = useDispatch();
  const toggle = () => {
    dispatch(toggleCampaignOnlyResultsThunk(!isActive));
  };

  if (!activeSalesCampaignCodes.length || !hasCampaignResults) {
    return null;
  }

  return (
    <Root className={props.className}>
      <Stack flexDirection={"row"} gap={2} alignItems={"center"}>
        <Typography variant="bodyLarge">{t("feature.salesCampaign.searchFilter")}</Typography>
        <SaleTag size={24} />
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Switch checked={isActive} onChange={toggle} />

        <Typography variant="bodyLarge">
          {isActive ? t("common.toggle.on.text") : t("common.toggle.off.text")}
        </Typography>
      </Stack>
    </Root>
  );
};

const Root = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: ICON_MARGIN,
  padding: "8px 12px",
}));
